import React, { ReactElement } from 'react'
import { Columns, ColumnProps } from '@lightspeed/design-system-react'

interface FormRowProps {
  children: ReactElement<ColumnProps> | Array<ReactElement<ColumnProps>>
}

export const FormRow: React.FC<FormRowProps> = ({ children }) => {
  return (
    <div className="vd-mb6">
      <Columns space={0}>{children}</Columns>
    </div>
  )
}
